<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary" @click="exportData"
            v-loading="exportButtonLoading" :disabled="exportButtonLoading">导出</el-button>
            <el-dropdown v-if="tableAcl.indexOf('Print') != -1" @command="print1">
              <el-button v-if="tableAcl.indexOf('Print') != -1" class="btn primary" type="primary">
                打印
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
  
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="0">打印</el-dropdown-item>
                <el-dropdown-item command="1">预览</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          <SelectFilter  v-if="system_setting.IsUseWard" ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
            <SelectFilter v-else ref="selectFilter" :options="filterOptions1" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
        </div>
      </div>
      <div style="margin-bottom: 5px;">
        <div  v-loading="loading">
          <span>当前已选重点科室：</span>
          <el-tag style="margin: 0 3px;" v-for="(item, index) in keyDeptNames" :key="index">{{item}}</el-tag>
        </div>
        
      </div>
      <el-table ref="multipleTable" v-loading="loading" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading" border :data="tableData" :max-height="tableHeight"
        :summary-method="getSummaries" show-summary style="width: 100%" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
   
        <el-table-column show-overflow-tooltip width="120" prop="financeCategoryName" label="财务分类"></el-table-column>
        <el-table-column show-overflow-tooltip width="120" prop="startStockAmount" label="期初金额"
        ></el-table-column>
        <el-table-column  label="本期增加" align="center">
          <el-table-column :key="'purchaseInStockAmount'" width="120" prop="purchaseInStockAmount"
            label="采购入库"></el-table-column>
          <el-table-column :key="'collectInStockAmountOfKeyDepts'" width="110" prop="collectInStockAmountOfKeyDepts"
            label="全院退回重点科室领用退库"></el-table-column>
            <el-table-column :key="'applyInStockAmountOfOtherDepts'" width="110" prop="applyInStockAmountOfOtherDepts"
            label="全院退回其他科室请领退库"></el-table-column>
            <el-table-column :key="'stockTransferInAmount'" width="120" prop="stockTransferInAmount"
            label="调拨入库"></el-table-column>
            <el-table-column :key="'stockProfitAmount'" width="120" prop="stockProfitAmount"
            label="盘盈入库"></el-table-column>
            <el-table-column :key="'periodInStockAmount'" width="120" prop="periodInStockAmount"
            label="期初入库"></el-table-column>
            <el-table-column :key="'stockGainsAmount'" width="120" prop="stockGainsAmount"
            label="库存损益（益）"></el-table-column>
            <el-table-column :key="'inStockAmount'" width="120" prop="inStockAmount"
            label="合计"></el-table-column>
        </el-table-column>
        <el-table-column  label="本期减少" align="center">
          <el-table-column :key="'purchaseOutStockAmount'" width="120" prop="purchaseOutStockAmount"
            label="采购退货"></el-table-column>
          <el-table-column :key="'collectOutStockAmountOfKeyDepts'" width="110" prop="collectOutStockAmountOfKeyDepts"
            label="全院出库重点科室领用出库"></el-table-column>
            <el-table-column :key="'applyOutStockAmountOfOtherDepts'" width="110" prop="applyOutStockAmountOfOtherDepts"
            label="全院出库其他科室请领出库"></el-table-column>
            <el-table-column :key="'stockTransferOutAmount'" width="120" prop="stockTransferOutAmount"
            label="调拨出库"></el-table-column>
            <el-table-column :key="'stockProfitLossAmount'" width="120" prop="stockProfitLossAmount"
            label="盘亏出库"></el-table-column>
            <el-table-column :key="'periodOutStockAmount'" width="120" prop="periodOutStockAmount"
            label="期初出库"></el-table-column>
            <el-table-column :key="'stockGainsLossAmount'" width="120" prop="stockGainsLossAmount"
            label="库存损益（损）"></el-table-column>
            <el-table-column :key="'lossOutStockAmount'" width="120" prop="lossOutStockAmount"
            label="报损出库"></el-table-column>
            <el-table-column :key="'outStockAmount'" width="120" prop="outStockAmount"
            label="合计"></el-table-column>
        </el-table-column>
 
        <el-table-column width="160" prop="endStockAmount" label="期末金额"></el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>
 
<script>
import { ExportFinancialStatementsExtra, GetFinancialStatementsExtra,GetFinancialStatementsExtraPrintData } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import SelectFilter from "@/components/table-select-filter";
import { LevelOptions } from "@/enum";
import BaseListMixin from '@/mixin/baseList-mixin.js'
 
export default {
  mixins: [GetDataSpdMixin, GetDataMixin,BaseListMixin], //BaseListMixin
  components: {
    SelectFilter,
  },
  data() {
    return {
      exportAction: ExportFinancialStatementsExtra,
      LevelOptions: LevelOptions,
      PrintAction: GetFinancialStatementsExtraPrintData,
      filterOptions1: [
        {
          name: "财务分类",
          type: "selectTree",
          code: "financeCategoryIds",
          filterMethod: this.getFinanceTypes,
          multiple: true,
          checkStrictly:true,
          defaultProps: {
            children: "children",
            label: "name",
          }, 
          data: [],
        },
        {
          name: "重点科室",
          type: "select",
          code: "keyDeptIds",
          filterMethod: this.getDepts,
          data: [],
          multiple: true,
        },
        {
          name: "时间范围",
          type: "datetimerange",
          code: "date",
          format:'yyyy-MM-dd HH:mm:ss',
        },
      ],
      filterOptions: [
        {
          name: "财务分类",
          type: "selectTree",
          code: "financeCategoryIds",
          filterMethod: this.getFinanceTypes,
          checkStrictly:true,
          multiple: true,
          defaultProps: {
            children: "children",
            label: "name",
          }, 
          data: [],
        },
        {
          name: "重点科室",
          type: "select",
          code: "keyDeptAndWardIds",
          filterMethod: this.getDeptAndWards1,
          ward:true,
          data: [],
          multiple: true,
        },
        {
          name: "时间范围",
          type: "datetimerange",
          code: "date",
          format:'yyyy-MM-dd HH:mm:ss',
        },
      ],
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      // 新增、编辑的数据
      form: {},
      loading: false,
      editMode: false,
      stockBalanceLogList: [],
      tableData: [],
      totalData: [],
      productPageTotal: 0,
      patientPageTotal: 0,
      total: 0,
      query: {
        pageIndex: 1,
        pageSize: 10,
      },
      keyDeptNames:[],
      dataTotalObj: {},
      warehouseLevel: 0,
      allDepts: [], // 添加一个存储所有科室的数组
    };
  },
  methods: {
   
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        for (const key in this.dataTotalObj) {
          if (column.property == key) {
            if (key.includes("Amount")) {
              sums[index] = this.dataTotalObj[key] + "元";
            } else {
              sums[index] = this.dataTotalObj[key];
            }
          }
        }
      });
      return sums;
    },
    // 编辑
    handleInfo1(row) {
      this.resetForm();
      this.form = JSON.parse(JSON.stringify(row));
      this.open = true;
      this.title = "查看";
      this.editMode = false;
    },
    resetForm() {
      this.form = {
        id: 0,
        warehouseId: "",
        startDate: "",
        endDate: "",
        viewMode:0,
        orgCode :sessionStorage.getItem('orgId'),
      };
    },
    // 取消编辑
    cancel() {
      this.$store.dispatch('SetLoading', false)
      this.open = false;
    },
    getData() {
      this.loading = true;
      GetFinancialStatementsExtra(this.query)
        .then((res) => {
          if (res.successful) {
            // this.warehouseLevel = res.returnData.dataTotalObj.warehouseLevel;
            this.totalData = res.returnData.data;
            this.total = this.totalData ? this.totalData.length : 0;
            this.tableData = this.getPaginationData(
              this.totalData,
              this.query.pageIndex,
              this.query.pageSize
            );
            if( res.returnData.keyDeptNames!=''){
              this.keyDeptNames =  res.returnData.keyDeptNames?.split(';')
            }else{
              this.keyDeptNames = []
            }
            if(this.system_setting.IsUseWard){
                this.query.keyDeptAndWardIdsName = this.keyDeptNames
              } else{
                this.query.keyDeptIdsName = this.keyDeptNames
              }
            this.dataTotalObj = res.returnData.dataTotalObj;
          } else {
            this.$message.error(`${res.errorMessage}`);
          }
        })
        .finally(() => {
          this.$nextTick(() => {
            this.loading = false;
            this.$refs.multipleTable.doLayout();
          });
        });
    },
 
    getPaginationData(list, pageIndex, pageSize) {
      return list.slice((pageIndex - 1) * pageSize, pageIndex * pageSize);
    },
    printList(command) {
      this.query.type = command;
 
      // GetStockBalancePrintData(this.query)
      //   .then(res => {
      //     var result = res.returnData
 
      //     var printData = this.printDataConvert(result.printData)
      //     this.sendPrintMessage(JSON.stringify(printData));
      //   })
    },
    // 重置
    reset() {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        viewMode:0,
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.getData();
    },
    // 改变当前页
    changePage(val) {
      this.$set(this.query, "pageIndex", val);
      this.tableData = this.getPaginationData(
        this.totalData,
        this.query.pageIndex,
        this.query.pageSize
      );
    },
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      this.tableData = this.getPaginationData(
        this.totalData,
        this.query.pageIndex,
        this.query.pageSize
      );
    },
    print1(command) {
      
      this.query.type = command;
      this.PrintAction(this.query)
        .then((res) => {
          var result = res.returnData;
          var printData = this.printDataConvert(result.printData);
          this.sendPrintMessage(JSON.stringify(printData));
        });
    },
  },
  created() { },
 
  
  mounted() {
  
  },
  updated() {
   
    
  },
};
</script>
 
<style lang="scss" scoped>
/deep/ .el-table__header-wrapper {
  height: 100% !important;
}
 
.warehouseName {
  color: #136af2;
}
 
.warehouseName:hover {
  cursor: pointer;
}
 
/deep/.el-dialog__body {
  overflow: auto !important;
}
</style>